<template>
  <div id="app" class="d-flex flex-column">
    <TilHeader/>
    <main class="main-content container pb-5">
      <transition name="page">
        <router-view/>
      </transition>
    </main>
    <TilFooter :isShowLinks="!$route.meta.hideFooter" />
    <MessageAlert />
    <CookieAlert />
  </div>
</template>
 
<script>
import TilHeader from './components/TilHeader'
import TilFooter from './components/TilFooter'
import MessageAlert from './components/elements/MessageAlert'
import CookieAlert from './components/elements/CookieAlert'

export default {
  components: {
    TilHeader,
    TilFooter,
    MessageAlert,
    CookieAlert
  }
}
</script>

<style lang="scss">
@import "./style/app.scss";
#app{
  min-height: 100vh;
}
.main-content{
  flex: 1;
}
.page-enter-active, .page-leave-active {
  transition: all 0.2s;
}
.page-enter {
  opacity: 0;
  transform: translateY(10px);
}
</style>
